import {
  navigateTo,
  getPatients,
  getUsers,
  addUserToClinic,
  getPaitentsWithNoClinic,
  getAdmins,
  getClinicData,
  setSuccess,
  setError
} from "../../redux/actions";
import { connect } from "react-redux";
import React, { Component } from "react";
import {
  Divider,
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
} from "@material-ui/core";

import AdminLayout from "../user/admin/AdminLayout";
import QrCode from "../common/QrCode";
import Header from "../common/Header";
import {
  adminPanelBaseStyles,
  patientDetailsStyles,
  baseStyles,
} from "../../theme/style";
import  PatientList  from "./PatientList";
import Cookies from "js-cookie";
import BackToPage from "../common/back-to-page";
import ClinicUserModal from "../clinic/ClinicUserModal";
import { Items, Storage } from "../../utils/StorageHelper";
import UserList from "../user/UserList";
import { getList, getNextPage, isAdmins, isClinicPatients, isClinicUsers, isNonPaitentsClinic, isPaitents, isUsers } from "../../utils/CFuncs";
import { headerEntity, urls } from "../../utils/Objects";
import Alerts from "../common/Alerts";

class PaitentsPanel extends Component {
constructor(props){
  super(props)


}

  render() {

    const selectedClinic = this.props.selectedClinic 

    return (
      <div>
        <AdminLayout {...this.props}>
        <Alerts />
          <div navstyle={patientDetailsStyles.navstyle}>
            <BackToPage link={urls.clinics} text="clinics" />
          </div>


          <div style={styles.container}>
            {selectedClinic && (isClinicUsers() || isClinicPatients() )&& (
                
              <div style={styles.qrContainer}> 
                <QrCode
                name={selectedClinic?.name}
                id={selectedClinic?.id?.toString()}
                />
              </div>
              )}
              <Header
              />

          
          </div>
         
          {(isUsers() || isAdmins()) && <UserList  /> }
          {(isPaitents() || isNonPaitentsClinic()) && <PatientList  />}
          <Divider />
   


        </AdminLayout>
      </div>

    );
  }
}

const styles = {
  qrContainer:{
    width:'100%',
    display:'flex',
    flexDirection:'column',
    
  },
  
  container: {
    width: "75vw",
  },
  container1: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
  },
  button: {
    cursor: "pointer",
    backgroundColor: "#4CAF50",
    border: "none",
    color: "white",
    padding: 7,
    textAlign: "center",
    textDecoration: "none",
    display: "inline-block",
    fontSize: 16,
    userSelect: "none",
  },
};
const mapStateToProps = (state, ownProps) => {
  let selectedClinic = state.clinic.selectedClinic  ;
  console.log({ selectedClinic });
  return {
    login: state.login,
    user: state.user,
    message: state.message,
    clinic: state.clinic,
    selectedClinic,
    
    
  }
};

const mapDispatchToProps = {
  navigateTo,
  getPatients,
  getUsers,
  addUserToClinic,
  getPaitentsWithNoClinic,
  getUsers,
  getAdmins,
  getClinicData,
  setSuccess,
  setError,
};
export default connect(mapStateToProps, mapDispatchToProps)(PaitentsPanel);
 
